import Rest from './../services/rest'
import Auth from './../services/auth'
import router from './../router/router'
import VueI18n from 'vue-i18n'
import Vue from 'vue'

Vue.use(VueI18n)
export default {
  alertSuccess (contex) {
  },
  getGroups (contex) {
    return new Promise((resolve, reject) => {
      return Rest.request(`GET`, `/groups`).then((data) => {
        data.forEach((podskupina, index) => {
          podskupina.showEdit = false
        })
        contex.commit(`updateGroupList`, data)
        resolve()
      }).catch((err) => {
        console.log(err)
        reject()
      })
    })
  },
  getAllGroups (contex) {
    return new Promise((resolve, reject) => {
      return Rest.request(`GET`, `/groups`).then((data) => {
        data.forEach((podskupina, index) => {
          podskupina.showEdit = false
        })
        contex.commit(`updateAllGroups`, data)
        resolve()
      }).catch((err) => {
        console.log(err)
        reject()
      })
    })
  },
  getGroupsNew (contex) {
    return new Promise((resolve, reject) => {
      return Rest.request(`GET`, `/years`).then((data) => {
        data.archived.forEach((podskupina, index) => {
          podskupina.showEdit = false
          podskupina.showEditYear = false
          podskupina.showCreateYear = false
        })
        data.myGroups.forEach((podskupina, index) => {
          podskupina.showEdit = false
          podskupina.showEditYear = false
          podskupina.showCreateYear = false
        })
        data.otherGroups.forEach((podskupina, index) => {
          podskupina.showEdit = false
          podskupina.showEditYear = false
          podskupina.showCreateYear = false
        })
        contex.commit(`updateGroupList`, data)
        resolve()
      }).catch((err) => {
        console.log(err)
        reject()
      })
    })
  },
  getGroup (contex, groupData) {
    return new Promise((resolve, reject) => {
      return Rest.request(`GET`, `/groups/${groupData.gid}/years/${groupData.yid}/subgroups/${groupData.sid}`).then((data) => {
        contex.commit(`updateSelectedGroup`, data)
        contex.commit(`updateSelectedGroupId`, data.group.id)
        contex.commit(`updateSubgroupsBreadcrumbs`, data.breadcrumbs)
        let year = data.years.find(year => year.id === data.selectedYearId)
        contex.commit('updateSelectedYear', year)
        resolve()
      }).catch((err) => {
        console.log(err)
        reject(err)
      })
    })
  },
  eraseExerciseFromSubgroup (contex, deleteData) {
    return new Promise((resolve, reject) => {
      return Rest.request(`DELETE`, `/subgroups/${deleteData.subgroupId}/exercises`, deleteData).then((data) => {
        resolve(data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  updateLanguage (contex, lokale) {
    return new Promise((resolve, reject) => {
      let lngCode = 86
      if (lokale === `sl`) lngCode = 86
      else if (lokale === `en`) lngCode = 33
      let putdata = {
        lngId: lngCode // contex.getters.getCurrentLanguage
      }
      return Rest.request(`PUT`, `/users/me`, putdata).then((data) => {
        contex.dispatch(`getUserData`)
        resolve()
      }).catch((err) => {
        console.log(err)
        reject(err)
      })
    })
  },
  getUserData (contex) {
    return Rest.request(`GET`, `/users/me`).then((data) => {
      contex.commit(`updateUserData`, data)
    }).catch(function (err) {
      console.log(err)
    })
  },
  logout (contex) {
    return Rest.request(`GET`, `/logout`).then((data) => {
      contex.commit(`updateUserData`, ``)
      Auth.removeAfterLogout()
      router.push({name: `home`})
    }).catch(function (err) {
      console.log(err)
    })
  },
  verifyToken (contex, token) {
    return Rest.request(`GET`, `/tokens/verify/${token}`)
  },
  setPassword (contex, passwordObj) {
    return Rest.request(`POST`, `/users/resetPassword`, passwordObj)
  },
  register (contex, data) {
    const { callback, dataForRegistration } = data
    return Rest.request(`POST`, `/users/register`, dataForRegistration).then((data) => {
      contex.commit(`updateRegisterStatus`, `true`)
      contex.commit(`resetRegisterForm`)
      callback()
    }).catch((err) => {
      contex.commit(`updateRegisterStatus`, err.responseJSON.message)
    })
  },
  login (contex, dataForLogin) {
    return new Promise((resolve, reject) => {
      return Rest.request(`POST`, `/login`, dataForLogin).then((data) => {
        contex.commit(`updateLoginStatus`, ``)
        contex.commit(`updateUserData`, data.user)
        resolve()
      }).catch((err) => {
        contex.commit(`updateLoginStatus`, err.responseJSON[`message`])
        contex.commit(`updateLoginSubmited`, true)
        console.log(err)
        reject(err)
      })
    })
  },
  loginGoogle (contex, googleSsoData) {
    return new Promise((resolve, reject) => {
      return Rest.request(`POST`, '/login/sso/google', googleSsoData).then((data) => {
        contex.commit(`updateLoginStatus`, ``)
        contex.commit(`updateUserData`, data.user)
        resolve()
      }).catch((err) => {
        contex.commit(`updateLoginStatus`, err.responseJSON[`message`])
        contex.commit(`updateLoginSubmited`, true)
        console.log(err)
        reject(err)
      })
    })
  },
  checkIfUsernameAndStudentIdAreSet (contex) {
    return new Promise((resolve, reject) => {
      return Rest.request(`GET`, `/users/me`).then((data) => {
        if (data.username && data.studentId) {
          reject()
        } else {
          contex.commit(`updateUserData`, data)
          resolve(data)
        }
      }).catch(function () {
        reject()
      })
    })
  },
  setUsernameAndStudentId (contex, userData) {
    return new Promise((resolve, reject) => {
      return Rest.request(`PUT`, `/users/me`, userData).then((data) => {
        contex.dispatch(`getUserData`)
        resolve()
      }).catch((err) => {
        console.log(err)
        reject(err)
      })
    })
  },
  getAnnounced (contex, searchQuery) {
    if (searchQuery === ``) searchQuery = undefined
    let deviceData = {
      query: searchQuery,
      sortBy: contex.state.exam.announcedTableState.sortBy,
      sortOrder: contex.state.exam.announcedTableState.sortOrder,
      limit: contex.state.exam.announcedTableState.limit
    }
    return Rest.request(`POST`, `/devices/search/announced`, deviceData).then((data) => {
      contex.commit(`updateAnnouncedDevices`, data)
    }).catch((err) => {
      console.log(err)
    })
  },
  deleteDevice (contex, id) {
    let dataForDelete = {
      id: id,
      password: contex.state.exam.mutationDevice.password
    }
    return new Promise((resolve, reject) => {
      return Rest.request(`DELETE`, `/devices/${id}`, dataForDelete).then((data) => {
        resolve(data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  resetDeviceApprovementChoice (contex) {
    contex.commit(`updateDeviceIdentifier`, ``)
    contex.commit(`updateDeviceName`, ``)
    contex.commit(`updateDeviceGroup`, ``)
    contex.commit(`updateDeviceComment`, ``)
    contex.commit(`updateDevicePassword`, ``)
  },
  approveDevice (contex, identifier) {
    if (identifier !== contex.state.exam.mutationDevice.identifier) {
      contex.dispatch(`resetDeviceApprovementChoice`)
    }
    return new Promise((resolve, reject) => {
      return Rest.request(`POST`, `/devices`, contex.state.exam.mutationDevice).then((data) => {
        alert(data.message + `\nCode for tablet: ${data.code}`)
        contex.dispatch(`resetDeviceApprovementChoice`)
        resolve(data)
      }).catch((err) => {
        console.log(err)
        alert(err.responseJSON[`message`])
        reject(err)
      })
    })
  },
  editDevice (contex, id) {
    return new Promise((resolve, reject) => {
      return Rest.request(`PUT`, `/devices/${id}`, contex.state.exam.mutationDevice).then((data) => {
        contex.dispatch(`resetDeviceApprovementChoice`)
        resolve(data)
      }).catch((err) => {
        console.log(err)
        alert(err.responseJSON[`message`])
        reject(err)
      })
    })
  },
  getAllDevices (contex, searchQuery) {
    if (searchQuery === ``) searchQuery = undefined
    let deviceData = contex.state.exam.tableStateAll
    contex.commit(`updateTableStateAllExercise`, {key: `query`, value: searchQuery})
    return Rest.request(`POST`, `/devices/search`, deviceData).then((data) => {
      contex.commit(`updateAllDevices`, data)
    }).catch((err) => {
      console.log(err)
    })
  },
  getAllExercises (contex, searchQuery) {
    if (searchQuery === ``) searchQuery = undefined
    let exerciseData = contex.state.exercises.tableStateAll
    exerciseData[`query`] = searchQuery
    return Rest.request(`POST`, `/exercises/search`, exerciseData).then((data) => {
      contex.commit(`updateAllExercises`, data)
    }).catch(function (err) {
      console.log(err)
    })
  },
  clearExerciseFields (contex) {
    contex.commit(`updateQuestionObject`, {key: ``, value: ``})
  },
  submitExercise (contex, submitExercise) {
    let submitFinal = {
      exerciseVersionId: submitExercise.exerciseVersionId, // required
      submitType: submitExercise.submitType || 'final', // tmp, final
      questionGUID: submitExercise.entireQuestion.guid, // required
      languageCode: contex.getters.getExerciseLanguage, // required, display language of the exercise: "sl", "en-us
      yearId: submitExercise.yearId,
      answer: submitExercise.selectedAnswer // required RADIO: answerGUID, MULTICHOICE: array of [answerGUIDs], NUMERICAL: answered number, ESSAY: answered string.
    }
    // if selected answer has been cleared nullify the empty array
    // done here so it doesn't mess with array functions when answer is an array
    if (submitExercise.selectedAnswer && !submitExercise.selectedAnswer[0]) {
      submitFinal.answer = null
    }
    if (submitExercise.classExamId) {
      submitFinal.classExamId = submitExercise.classExamId
    } else {
      submitFinal.subgroupId = submitExercise.sid
    }
    return Rest.request(`POST`, `/exercises/submit`, submitFinal)
  },
  hintExercise (contex, submitHint) {
    let arr = []
    for (let i = 0; i < submitHint.entireQuestion.hintCount && i <= submitHint.hintNumber; i++) arr.push(i)
    let submitFinal = {
      exerciseVersionId: submitHint.exerciseVersionId,
      questionGUID: submitHint.entireQuestion.guid,
      languageCode: contex.getters.getExerciseLanguage,
      yearId: submitHint.yearId,
      subgroupId: submitHint.sid,
      hintIndexes: arr
    }
    return Rest.request(`POST`, `/exercises/hints`, submitFinal)
  },
  showSolution (contex, submitSolution) {
    console.log('submit solution je: ', submitSolution)
    let submitFinal = {
      exerciseVersionId: submitSolution.exerciseVersionId,
      questionGUID: submitSolution.entireQuestion.guid,
      languageCode: contex.getters.getExerciseLanguage,
      yearId: submitSolution.yearId,
      subgroupId: submitSolution.sid
    }
    console.log(submitFinal)
    return Rest.request(`POST`, `/exercises/solution`, submitFinal)
  },
  showSolutionNew (contex, params) {
    console.log('contex: ', contex)
    console.log('params: ', params)

    return Rest.request('POST', '/exercises/find', params)
  },
  generateDevice (contex, id) {
    let dataForGenerate = {
      id: id,
      password: contex.state.exam.mutationDevice.password
    }
    return new Promise((resolve, reject) => {
      return Rest.request(`PUT`, `/devices/${id}/secret`, dataForGenerate).then((data) => {
        resolve(data)
      }).catch((err) => {
        reject(err)
      })
    })
  },
  exercisesForProgressGet (contex, getData) {
    return Rest.request(`GET`, `/subgroups/${getData.pid}/${getData.showVisible}`).then((data) => { // TODO: should be false in production
      contex.commit(`updateExercisesInOrder`, data)
    }).catch((err) => {
      console.log(err)
    })
  },
  updateExerciseOrderInSubgroup (contex, obj) {
    return new Promise((resolve, reject) => {
      contex.commit(`updateExercisesInOrder`, obj.val)
      resolve()
    }).then(() => {
      let putData = {
        subgroupId: obj.pid,
        orders: contex.getters.getNewOrderOfExercises
      }
      return Rest.request(`PUT`, `/subgroups/exercises/order/${obj.pid}`, putData).then((data) => {
      }).catch((err) => {
        console.log(err)
      })
    })
  },
  updateModalForExercise (contex, exerciseId) {
    return new Promise((resolve, reject) => {
      return Rest.request(`GET`, `/exercises/${exerciseId}`).then((data) => {
        data.data.exerciseId = data.exerciseId
        contex.commit(`updateExerciseForModal`, data.data)
        resolve()
      }).catch((err) => {
        console.log(err)
        reject()
      })
    })
  },
  submitEditedExercise (contex, data) {
    let postdata = {
      exerciseId: data.exerciseId,
      data: data.data
    }
    return Rest.request(`POST`, `/exercises/updateContents/${data.exerciseId}`, postdata).then((data) => {
    }).catch((err) => {
      console.log(err)
    })
  },
  getGlobalStatistics (contex, data) {
    return new Promise((resolve, reject) => {
      let postdata = {
        fields: [`registerCount`, `activeCount`, `correctCount`, `wrongCount`]
      }
      return Rest.request(`POST`, `/statistics/global`, data || postdata).then((data) => {
        contex.commit(`updateGlobalStatistics`, data)
        resolve()
      }).catch((err) => {
        console.log(err)
        reject(err)
      })
    })
  },
  /*
  getDailyChallenges (contex, data) {
    return new Promise((resolve, reject) => {
      return Rest.request(`GET`, `/groups/${data.gid}/years/${data.yid}`).then((data) => {
        contex.commit(`updateDailyChallenges`, data.dailyChallenges)
        resolve()
      }).catch((err) => {
        console.log(err)
      })
    })
  },
  */
  getSubgroups (contex, data) {
    if (!data.level) data.level = 'root'
    return new Promise((resolve, reject) => {
      return Rest.request(`GET`, `/groups/${data.gid}/years/${data.yid}/subgroups/${data.level}`).then((data) => {
        contex.commit(`updateSubgroups`, data.subgroups)
        contex.commit(`updateDailyChallenges`, data.dailyChallenges)
        console.log(data)
        resolve()
      }).catch((err) => {
        console.log(err)
      })
    })
  },
  getReports (contex, data) {
    return new Promise((resolve, reject) => {
      return Rest.request('GET', '/exerciseReports').then(function (data) {
        contex.commit(`updateReports`, data)
      }).catch(function (err) {
        console.log(err)
      })
    })
  },
  exercisesForOrderGet (contex, data) {
    console.log(data)
    return Rest.request('GET', `/groups/${data.gid}/years/${data.yid}/subgroups/${data.pid}`).then((data) => { // TODO: should be false in production
      contex.commit(`updateExercisesForOrder`, data.subgroupExercises)
    }).catch((err) => {
      console.log(err)
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js